import React, { useEffect, useRef, useState } from 'react';
import { Carousel, Skeleton } from 'antd';
import { ExternalResourceSlide } from '/react4xp/parts/external-resources/components/external-resource-slide';
import { DEFAULT_SLIDE_SIZE } from '/react4xp/parts/external-resources/external-resources.constants';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import './external-resources.scss';
import { CarouselRef } from 'antd/es/carousel';
import Button from '/react4xp/mixins/ui/button/button';
import {getExtResList} from "/react4xp/parts/service-link-img/actions";

const NextArrow = ({ currentSlide, slideCount, ...props }: any) => (
    <Button
        type="primary"
        shape="circle"
        icon={<RightOutlined />}
        color="blue"
        {...props}
    />
);

const PrevArrow = ({ currentSlide, slideCount, ...props }: any) => (
    <Button
        type="primary"
        shape="circle"
        icon={<LeftOutlined />}
        color="blue"
        {...props}
    />
);

const ExternalResources = (props: any) => {
    const [width, setWidth] = useState<number>();
    const carouselRef = useRef<CarouselRef>();
    const wrapperRef = useRef<HTMLDivElement>();
    const [frames, setFrames] = useState<any[]>();
    const [slideSize, setSlideSize] = useState<number>();

    useEffect(() => {
        const widthObserver = new ResizeObserver((entries) => {
            setWidth(entries[0].contentRect['width']);
        });

        if (carouselRef.current) {
            widthObserver.observe(wrapperRef.current);
        }

        return () => {
            widthObserver.disconnect();
        };
    }, []);

    useEffect(() => {
        if (width) {
            const frameCapacity = Math.floor(width / props.config.size || DEFAULT_SLIDE_SIZE) || 1;
            const size = (props.config.expand && (width - (frameCapacity - 1) * 15) / frameCapacity) || props.config.size;

            setSlideSize(size);

            getExtResList(props.language, props.context).then(
                value => {
                    const banners = value.data;
                    const fr = [];

                    for (let i = 0; i < banners.length; i += frameCapacity) {
                        fr.push(banners.slice(i, i + frameCapacity));
                    }

                    setFrames(fr);
                });
        }
    }, [width]);

    return (
        <div
            className="external-resources-block my-3"
            ref={wrapperRef}
        >
            <h3>{props.config.title}</h3>

            {frames ? (
                <Carousel
                    autoplay
                    autoplaySpeed={7000}
                    arrows
                    ref={carouselRef}
                    nextArrow={<NextArrow />}
                    prevArrow={<PrevArrow />}
                >
                    {frames.map((frame, index) => (
                        <div
                            className="slides-frame"
                            key={index}
                        >
                            {frame.map(({ id, title, imageSrc, url }) => (
                                <ExternalResourceSlide
                                    key={id}
                                    title={title}
                                    url={url}
                                    imageSrc={imageSrc}
                                    size={slideSize}
                                />
                            ))}
                        </div>
                    ))}
                </Carousel>
            ) : (
                <Carousel
                    autoplay
                    autoplaySpeed={7000}
                    arrows
                    ref={carouselRef}
                    nextArrow={<NextArrow />}
                    prevArrow={<PrevArrow />}
                >
                    <div className="slides-frame" >
                        <Skeleton.Image active={true} />
                        <Skeleton.Image active={true} />
                        <Skeleton.Image active={true} />
                    </div>
                </Carousel>
            )}
        </div>
    );
};

export default ExternalResources;
